window.NodeList.prototype.forEach = Array.prototype.forEach
